import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'logged_out_retailers-builder_xp_bucketing-action_unknown';
/**
 * pass Builder XP data so that we could do custom assignment

parameters: &quot;featuretoggle&quot;, &quot;contentid&quot;, &quot;contentname&quot;, &quot;testvariationid&quot;, &quot;testvariationname&quot;
*/
export function trackLoggedOutRetailersBuilderXpBucketing(featuretoggle, contentid_string2, contentname_string3, testvariationid4, testvariationname5) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            featuretoggle,
            contentid_string2,
            contentname_string3,
            testvariationid4,
            testvariationname5,
        },
    });
}
